module.exports = __webpack_public_path__ + "static/fonts/Fact-Narrow.7e063d5.ttf";